import { Chip } from "$components/chip";
import { DateRangePicker } from "$components/inputs";
import { Box, Typography } from "@material-ui/core";
import { format } from "date-fns";
import React from "react";
import { useIntl } from "react-intl";
import { DATE_FORMAT } from "./constants";

export const RegisterTableHeader = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  setCurrentPage,
  total = 0,
  heading,
}: {
  startDate: string;
  endDate: string;
  setStartDate: React.Dispatch<React.SetStateAction<string>>;
  setEndDate: React.Dispatch<React.SetStateAction<string>>;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  total?: number;
  heading: React.ReactNode;
}) => {
  const { formatMessage } = useIntl();
  return (
    <Box
      sx={{
        alignItems: "center",
        flexDirection: "row",
        display: "flex",
        my: 1,
        justifyContent: "space-between",
      }}
    >
      <Typography variant="h3">{heading}</Typography>
      <Box sx={{ mx: 2, flexGrow: 1 }} justifyContent="left">
        <Chip
          label={formatMessage(
            {
              id: "register.totalRows",
              defaultMessage: "{total} rows",
            },
            { total },
          )}
        />
      </Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        fontSize="16px"
      >
        <DateRangePicker
          hideHelper
          fromValue={startDate}
          setFromValue={(v) => {
            setStartDate(format(v ? new Date(v) : new Date(), DATE_FORMAT));
            setCurrentPage(0); // reset pagination on date change
          }}
          toValue={endDate}
          setToValue={(v) => {
            setEndDate(format(v ? new Date(v) : new Date(), DATE_FORMAT));
            setCurrentPage(0); // reset pagination on date change
          }}
        />
      </Box>
    </Box>
  );
};
